export const isRent = () => {
    const config = useRuntimeConfig()

    return config.public.website === 'cromi.rent'
}
